module.exports = __webpack_public_path__ + "static/2019523:2c1962ccc3a792554197/img/wfft_2x.438e74f.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/wfft_2x.png
// module id = qzVD
// module chunks = 1